









import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";
import {Prop} from "vue-property-decorator";
import {ConfiguredImageDto, ImageFilterDto, ImageRequirementDto, ProductDto} from "@swagger";
import ImageBatchSelector from "@/components/product-configuration/ImageBatchSelector.vue";
import PersonSelector from "@/components/product-configuration/PersonSelector.vue";
import SetConfigurator from "@/components/product-configuration/SetConfigurator.vue";
import SingleConfigurator from "@/components/product-configuration/SingleConfigurator.vue";
import TypeEnum = ImageRequirementDto.TypeEnum;

@Component({
  components: {
    SingleConfigurator,
    ImageBatchSelector,
    SetConfigurator,
    PersonSelector,
    ImageSelectionRow: ImageBatchSelector
  }
})
export default class ProductConfigurator extends BasicComponent {

  @Prop(Object) product: ProductDto;

  selectedImages: ConfiguredImageDto[] = [];

  get isSet(): boolean {
    return this.product.detailedImageRequirements.length > 1;
  }

  get needsBatchSelection(): boolean {
    return this.product.imageRequirements[0].type === TypeEnum.ALLOFPERSON;
  }

  get availableFilters() {
    return Object.keys(ImageFilterDto).map(id => {
      return {
        id: id,
        name: this.$t(`FILTER_NAME_${id}`)
      }
    });
  }

  addedToBasket(): void {
    this.$emit("addedToBasket");
  }

  onError(error: string): void {
    this.$emit("error", error);
  }

}

